import { useCallback, useState } from 'react';
import style from './Textarea.module.scss';

export const useTextareaDropFilesHandler = (onFilesPaste: undefined | ((files: File[]) => void)) => {
    const [showUploadOverlay, setShowUploadOverlay] = useState(false);
    const handleDrop = useCallback((e: React.DragEvent<HTMLTextAreaElement>) => {
        setShowUploadOverlay(false);
        if (!onFilesPaste) {
            return;
        }
        const files = Array.from(e.dataTransfer.files || []);
        if (files.length === 0) {
            return;
        }

        e.preventDefault();
        onFilesPaste(files);

    }, [onFilesPaste]);


    const handleDragOver = useCallback((e: React.DragEvent<HTMLTextAreaElement>) => {
        if (!onFilesPaste) {
            return;
        }
        const hasFiles = e.dataTransfer.types.includes("Files");

        if (hasFiles) {
            e.preventDefault();
            setShowUploadOverlay(true);
        }
    }, [onFilesPaste]);
    const handleDragLeave = useCallback(() => {
        setShowUploadOverlay(false);
    }, []);
    const uploadOverlay = <span className={style.upload}></span>;

    return {
        uploadOverlay,
        showUploadOverlay,
        handleDragOver,
        handleDragLeave,
        handleDrop
    };
};